import * as React from "react";
import {
  Button,
  createStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Slide,
  TextField,
  Theme,
  withStyles,
} from "@material-ui/core";
import { API } from "aws-amplify";
import { TransitionProps } from "@material-ui/core/transitions";
import { LoadingSpinner } from "../../../../utils/LoadingSpinner";
import { Search as SearchIcon } from "@material-ui/icons";
import { Alert, AlertTitle } from "@material-ui/lab";
import InputAdornment from "@material-ui/core/InputAdornment/InputAdornment";
import CustomerResult from "./CustomerResult";

const styles = ({ spacing }: Theme) =>
  createStyles({
    buttonWrapper: {
      backgroundColor: "#00cc00",
      marginTop: spacing(1),
    },
    searchBar: {
      background: "white",
      width: "100%",
    },
  });

enum SearchStatus {
  NoQuery,
  Searching,
  ResultsFound,
  NotFound,
}

interface ISearchState {
  status: SearchStatus;
  formSubmitted: boolean;
  message: string;
  open: boolean;
  searchTerm: string;
  showLoadingSpinner: boolean;
  customer: any;
}

const TransitionConst = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement<any, any> },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

class SearchSection extends React.Component<any, ISearchState> {
  constructor(props: any) {
    super(props);
    this.state = {
      customer: "",
      formSubmitted: false,
      message: "",
      open: false,
      searchTerm: "",
      showLoadingSpinner: false,
      status: SearchStatus.NoQuery,
    };

    this.handleSearchTerm = this.handleSearchTerm.bind(this);
    this.handleValidation = this.handleValidation.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  public render() {
    return (
      <Grid item xs={12}>
        <Grid
          item
          xs={12}
          container
          justify="center"
          alignItems="stretch"
          spacing={3}
          alignContent="center"
        >
          {this.state.showLoadingSpinner && <LoadingSpinner />}
          <TextField
            autoFocus
            style={{ width: "100%", background: "white" }}
            label="Search Pharmacy Customer"
            variant="outlined"
            value={this.state.searchTerm}
            onChange={this.handleSearchTerm}
            onKeyPress={(event) => {
              if (event.key === "Enter") {
                this.handleSubmit();
              }
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            placeholder="Search : Email, CustomerId, ProfileId or PersonId"
          />
          <Grid item xs={12} sm={6} md={3} lg={2}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={this.handleSubmit}
            >
              Submit
            </Button>
          </Grid>
          <Grid item xs={12}>
            {this.state.formSubmitted && <LoadingSpinner />}
          </Grid>
        </Grid>
        {this.state.status === SearchStatus.ResultsFound && (
          <Grid item xs={12}>
            <Grid item xs={12}>
              {this.state.formSubmitted && <LoadingSpinner />}
              {this.state.status === SearchStatus.ResultsFound && (
                  <LoadingSpinner />
                ) && (
                  <CustomerResult
                    customer={this.state.customer}
                    heading={"Pharmacy Customer found"}
                  />
                )}
            </Grid>
          </Grid>
        )}
        {this.state.status === SearchStatus.NotFound && (
          <Grid item xs={12}>
            <Grid item xs={12}>
              <Alert variant="filled" severity="warning">
                <AlertTitle>Warning</AlertTitle>
                Customer not found! {this.state.searchTerm}
              </Alert>
            </Grid>
          </Grid>
        )}

        {this.state.message && (
          <Dialog
            open={this.state.open}
            TransitionComponent={TransitionConst}
            keepMounted
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
            onClose={this.handleClose}
          >
            <DialogTitle id="alert-dialog-slide-title">
              {"Search Response"}
            </DialogTitle>
            <DialogContent>
              {" "}
              <DialogContentText id="alert-dialog-slide-description">
                {this.state.message}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleClose} color="primary">
                Close
              </Button>
            </DialogActions>
          </Dialog>
        )}
      </Grid>
    );
  }

  public handleClose() {
    this.setState({ open: false });
  }

  public handleSearchTerm(event: React.ChangeEvent<HTMLInputElement>) {
    this.setState({ searchTerm: event.target.value });
  }

  private handleValidation() {
    let formIsValid = true;
    if (!this.state.searchTerm) {
      alert("Please enter the search term");
      formIsValid = false;
    }
    return formIsValid;
  }

  private handleSubmit() {
    if (this.handleValidation()) {
      this.setState({ formSubmitted: true });
      this.setState({ status: SearchStatus.Searching });

      const apiName = "ApaqPortalAPI";
      const path = "/pharmacy-customer/search/" + this.state.searchTerm;
      const config = {
        headers: {},
      };

      API.get(apiName, path, config)
        .then((usersFound: any) => {
          console.log("Response from data is ", usersFound);
          this.setState({ formSubmitted: false });
          this.setState({ searchTerm: "" });
          this.setState({ customer: usersFound });
          this.setState({ status: SearchStatus.ResultsFound });
        })
        .catch((error) => {
          console.log("Response is not found");
          console.log(error);
          this.setState({ open: true });
          this.setState({ formSubmitted: false });
          this.setState({ status: SearchStatus.NotFound });
        });
    }
  }
}

export default withStyles(styles)(SearchSection);
